export default "__VITE_ASSET___73XDPfg__"